<template>
  <div class="icon" :style="posStyle" :class="{ locked }" :title="title" aria-hidden="true">
    <img :src="src" :style="{ width: size + 'px', height: size + 'px' }" alt="" />
  </div>
</template>

<script>
export default {
  name: "BoardIcon",
  props: {
    x: { type: Number, required: true },         // design px
    y: { type: Number, required: true },         // design px
    design: { type: Object, required: true },    // { w, h }
    src: { type: String, required: true },
    size: { type: Number, default: 36 },         // px on screen
    locked: { type: Boolean, default: false },
    title: { type: String, default: "" }
  },
  computed: {
    posStyle() {
      const left = (this.x / this.design.w) * 100
      const top  = (this.y / this.design.h) * 100
      return { left: left + "%", top: top + "%" }
    }
  }
}
</script>

<style scoped>
.icon {
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 3;
  pointer-events: auto;
}
.locked { opacity: 0.7; }
img { display: block; }
</style>
